
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg","stroke":"#6C7684"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10.25","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M15.646 10.926c.805.474.805 1.674 0 2.148l-5.108 3.01c-.774.457-1.788-.097-1.788-1.073V8.989c0-.976 1.014-1.53 1.788-1.074l5.108 3.01z","stroke-width":"1.5"}})])
          )
        }
      }
    